/* unplugin-vue-components disabled */import script from "./BindWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./BindWallet.vue?vue&type=script&setup=true&lang=js"

import "./BindWallet.vue?vue&type=style&index=0&id=2f7d2216&lang=less"

const __exports__ = script;

export default __exports__